var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRiskLevel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.33317 3.83333H3.99984C3.64622 3.83333 3.30708 3.97381 3.05703 4.22386C2.80698 4.47391 2.6665 4.81304 2.6665 5.16667V13.1667C2.6665 13.5203 2.80698 13.8594 3.05703 14.1095C3.30708 14.3595 3.64622 14.5 3.99984 14.5H11.9998C12.3535 14.5 12.6926 14.3595 12.9426 14.1095C13.1927 13.8594 13.3332 13.5203 13.3332 13.1667V5.16667C13.3332 4.81304 13.1927 4.47391 12.9426 4.22386C12.6926 3.97381 12.3535 3.83333 11.9998 3.83333H10.6665M5.33317 3.83333C5.33317 3.47971 5.47365 3.14057 5.7237 2.89052C5.97374 2.64048 6.31288 2.5 6.6665 2.5H9.33317C9.68679 2.5 10.0259 2.64048 10.276 2.89052C10.526 3.14057 10.6665 3.47971 10.6665 3.83333M5.33317 3.83333C5.33317 4.18696 5.47365 4.52609 5.7237 4.77614C5.97374 5.02619 6.31288 5.16667 6.6665 5.16667H9.33317C9.68679 5.16667 10.0259 5.02619 10.276 4.77614C10.526 4.52609 10.6665 4.18696 10.6665 3.83333",
    stroke: "#7D7D7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 9.83325L7.33333 11.1666L10 7.83325",
    stroke: "#7D7D7D",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRiskLevel);
export default __webpack_public_path__ + "static/media/risk-level.859123d338b346801f40eb0687763056.svg";
export { ForwardRef as ReactComponent };